import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useSetAtom } from 'jotai'
import {
  BarChart3,
  Brain,
  ClipboardList,
  CreditCard,
  HelpCircle,
  Home,
  LayoutDashboard,
  LogOut,
  LucideIcon,
  Megaphone,
  Music2,
  Settings,
  UserCog,
  Users,
} from 'lucide-react'
import './Sidebar.scss'
import { drumtaleAdminSessionAtom } from '../../AtomStore'

interface NavItem {
  label: string
  icon: LucideIcon
  path?: string
}

const NAV_ITEMS: NavItem[] = [
  { label: '대시보드', icon: LayoutDashboard, path: '/admin/dashboard' },
  { label: '회원관리', icon: Users, path: '/admin/members' },
  { label: '구독관리', icon: CreditCard, path: '/admin/subscriptions' },
  { label: '악보관리', icon: Music2, path: '/admin/scores' },
  { label: '악보로그', icon: BarChart3, path: '/admin/score-logs' },
  { label: '인지플레이', icon: Brain, path: '/admin/cognitive' },
  { label: '인지로그', icon: ClipboardList, path: '/admin/cognitive-logs' },
  { label: '공지사항', icon: Megaphone, path: '/admin/notices' },
  { label: '설정', icon: Settings, path: '/admin/settings' },
  { label: '관리자 설정', icon: UserCog, path: '/admin/admin-settings' },
]

function Sidebar() {
  const navigate = useNavigate()
  const setIsAdminSessionActive = useSetAtom(drumtaleAdminSessionAtom)

  const handleLogout = () => {
    setIsAdminSessionActive(false)
    navigate('/')
  }

  return (
    <aside className='Sidebar'>
      <button
        className='brand'
        type='button'
        aria-label='대시보드로 이동'
        onClick={() => navigate('/admin/dashboard')}
      >
        <div className='brand-mark'>DT</div>
        <div>
          <strong>DrumTale</strong>
          <span>드럼테일</span>
        </div>
      </button>

      <nav className='main-nav' aria-label='관리자 메뉴'>
        {NAV_ITEMS.map(({ label, icon: Icon, path }) =>
          path ? (
            <NavLink key={label} to={path} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
              <Icon size={18} />
              {label}
            </NavLink>
          ) : (
            <button key={label} className='nav-item' type='button' disabled title='준비중'>
              <Icon size={18} />
              {label}
              <span className='nav-item-badge'>준비중</span>
            </button>
          ),
        )}
      </nav>

      <div className='sidebar-bottom-actions'>
        <button className='sidebar-home-button' type='button' onClick={() => navigate('/')}>
          <Home size={18} />
          홈
        </button>
        <button className='sidebar-logout-button' type='button' onClick={handleLogout}>
          <LogOut size={18} />
          로그아웃
        </button>
        <button className='sidebar-spec-button' type='button' aria-label='관리자 메뉴 전체 안내 열기' title='관리자 메뉴 전체 안내'>
          <HelpCircle size={18} />
        </button>
      </div>
    </aside>
  )
}

export default Sidebar
